import { useNavigate } from 'react-router-dom';
import { getResourceConfig } from './constants';
import { usePermissions } from './usePermissions';
import { usePermissionModal } from '../context/PermissionModalProvider';

export function useGuardedNavigation(resourceKey) {
  const navigate = useNavigate();
  const { canCreate, canUpdate } = usePermissions();
  const { showInsufficientPermissionModal } = usePermissionModal();
  const config = getResourceConfig(resourceKey);

  const navigateCreate = () => {
    if (!canCreate(resourceKey)) {
      showInsufficientPermissionModal();

      return;
    }

    navigate(`/${config.segment}/create`);
  };

  const navigateEdit = (id) => {
    if (!canUpdate(resourceKey)) {
      showInsufficientPermissionModal();

      return;
    }

    navigate(`/${config.segment}/${id}/edit`);
  };

  const navigateDetails = (id) => {
    navigate(`/${config.segment}/${id}`);
  };

  const guardCreate = () => canCreate(resourceKey);
  const guardUpdate = () => canUpdate(resourceKey);

  const runGuardedCreate = (callback) => {
    if (!canCreate(resourceKey)) {
      showInsufficientPermissionModal();

      return;
    }

    callback();
  };

  const runGuardedUpdate = (callback) => {
    if (!canUpdate(resourceKey)) {
      showInsufficientPermissionModal();

      return;
    }

    callback();
  };

  return {
    navigateCreate,
    navigateEdit,
    navigateDetails,
    guardCreate,
    guardUpdate,
    runGuardedCreate,
    runGuardedUpdate,
  };
}
